<div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
</div>
<div class="col-12" *ngIf="myLoader">
    <app-busy [message]="message"></app-busy>
</div>
<header>
    <h1 class="opensans-semi-bold-sapphire-30px">Permit Information</h1>
    <span><img *ngIf="isViewMode" class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20"
               alt="Vector 4" class="pull-icon" (click)="jumpToPermit()"/>
  </span>
</header>
<div class="row s-content">
    <div class="col-md-6">
        Account Name:
    </div>
    <div class="col-md-6">
        {{dataCntrl.carrier.name}}
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Vehicle Type:
    </div>
    <div class="col-md-6">
        {{vehicletype}}
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Permit Type:
    </div>
    <div class="col-md-6">
        {{permittype}}
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Permit Duration:
    </div>
    <div class="col-md-6">
        {{dataCntrl.durationSelected}}
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Type of carrier for permit:
    </div>
    <div class="col-md-6">
        <!--    {{carriertypeDec}}-->
        {{dataCntrl.carrier.carrier_type_name}}
    </div>
</div>
<br/>
<!-- <header>
    <h1 class="opensans-semi-bold-sapphire-30px">Vehicle Details</h1>
    <span><img *ngIf="isViewMode" class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20"
               alt="Vector 4" class="pull-icon" (click)="jumpToVehicle()"/>
  </span>
</header> -->
<br/>
<!-- <div classs="row s-content">
    <table class="table">
        <thead>
        <tr>
            <th scope="col">Vehicle Type</th>
            <th scope="col">Reg No.</th>
            <th scope="col">No. Passanger</th>
            <th scope="col">GVM</th>
            <th scope="col">VIN Number</th>
            <th scope="col">License/Roadworthy C.O.F Expiry Date</th>
            <th scope="col">Valid From</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let list of vehicles">
            <td>{{list.vehicle_type}}</td>
            <td>{{list.registration_number}}</td>
            <td>{{list.number_passengers}}</td>
            <td>{{list.gvn}}</td>
            <td>{{list.vin}}</td>
            <td>{{list.date_license_expiry}}</td>
            <td>{{list.start_date}}</td>
        </tr>

  </tbody>
</table>
</div> -->

<!-- beginning of changes-->

<header>
    <h1 class="opensans-semi-bold-sapphire-30px">Route and motivation</h1>
    <span><img *ngIf="isViewMode" class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20"
               alt="Vector 4" class="pull-icon" (click)="jumpToRoutes()"/>
  </span>
</header>
<div class="row s-content">
    <div class="col-md-6">
        Route:
    </div>
    <div class="col-md-6">
        <p [innerHTML]="dataCntrl.application.route_summary"></p>
       
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Motivation:
    </div>
    <div class="col-md-6">
        <p [innerHTML]="dataCntrl.application.motivation_detail"></p>
    </div>
</div>
<header>
    <h1 class="opensans-semi-bold-sapphire-30px">Documents</h1>
    <span><img *ngIf="isViewMode" class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20"
               alt="Vector 4" class="pull-icon" (click)="jumpToUploads()"/>
  </span>
</header>
<div class="row s-content">
    <app-document-viewer [uploadedDocs]="dataCntrl.uploadedDocs" style="width: 100%;"></app-document-viewer>
</div>


<div class="card border-light shadow-sm">
   

    <div class="row s-content">
        <div class="col-md-6" style="font-size: x-large; font: opensans-semi-bold-sapphire;">
            Account Balance 
        </div>
        <div class="col-md-6" [ngClass]="{'error-color':accBalance < 0}" style="text-align: right;">
            {{dataCntrl['carrier'].account_balance==null ? ' R 0.00' : dataCntrl['carrier'].account_balance}}
        </div>
    </div>
    <header>
        <h1 class="opensans-semi-bold-sapphire-30px">Amount Due</h1>
      <!--  <span><img class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20" alt="Vector 4" class="pull-icon"  />-->
      <!--  </span>-->
      </header>
     <table class="table table-striped" id="pdfTable">
       <thead>
        <tr>
            <th >Vehicle Registration </th>
            <th >Vehice Type</th>
            <th >Start Date</th>
            <th >End Date</th>
            <th >Permit Type</th>
            <!-- <th >Duration</th> -->
            <th >Application Fee</th>
            <th >Permit Fee</th>
            <th style="text-align:right;">Line Total</th>
          </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="vehicles.length > 0">
        <tr *ngFor="let list of vehicles">
          <td >{{list.registration_number}} </td>
          <td >{{list.vehicle_type}}</td>
          <td >{{list.start_date}}</td>
          <td >{{list.end_date}}</td>
          <td >{{dataCntrl['permittype'].description}}</td>
        <!--   <ng-container *ngIf="ptype == null">
            <td *ngIf="dataCntrl['permittype'].permit_years == 1">{{dataCntrl['permittype'].permit_years}} - Year</td>
            <td *ngIf="dataCntrl['permittype'].permit_years > 1">{{dataCntrl['permittype'].permit_years}} - Years</td>
            <td *ngIf="dataCntrl['permittype'].permit_months == 1">{{dataCntrl['permittype'].permit_months}} - Month</td>
            <td *ngIf="dataCntrl['permittype'].permit_months > 1">{{dataCntrl['permittype'].permit_months}} - Months</td>
            <td *ngIf="dataCntrl['permittype'].permit_days == 1">{{dataCntrl['permittype'].permit_days}} - Day</td>
            <td *ngIf="dataCntrl['permittype'].permit_days > 1">{{dataCntrl['permittype'].permit_days}} - Days</td>
          </ng-container>
          <ng-container *ngIf="ptype != null">
            <td *ngIf="ptypeYears == 1">{{ptypeYears}} - Year</td>
            <td *ngIf="ptypeYears > 1">{{ptypeYears}} - Years</td>
            <td *ngIf="ptypeMonth == 1">{{ptypeMonth}} - Month</td>
            <td *ngIf="ptypeMonth > 1">{{ptypeMonth}} - Months</td>
            <td *ngIf="ptypeDays == 1">{{ptypeDays}} - Day</td>
            <td *ngIf="ptypeDays > 1">{{ptypeDays}} - Days</td>
          </ng-container> -->
            <td  [ngClass]="{'error-color':chargeInd!=0}">{{formatCurrency(list.application_fee)}}</td>
            <td  [ngClass]="{'error-color':chargeInd==2}">{{formatCurrency(list.permit_fee)}}</td>
            <td style="text-align: right;">{{formatCurrency(lineTotal)}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="vehicles==null ||vehicles.length==0">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td >{{dataCntrl['permittype'].description}}</td>
                <!-- <td *ngIf="dataCntrl['permittype'].permit_years == 1">{{dataCntrl['permittype'].permit_years}} - Year</td>
                <td *ngIf="dataCntrl['permittype'].permit_years > 1">{{dataCntrl['permittype'].permit_years}} - Years</td>
                <td *ngIf="dataCntrl['permittype'].permit_months == 1">{{dataCntrl['permittype'].permit_months}} - Month</td>
                <td *ngIf="dataCntrl['permittype'].permit_months > 1">{{dataCntrl['permittype'].permit_months}} - Months</td>
                <td *ngIf="dataCntrl['permittype'].permit_days == 1">{{dataCntrl['permittype'].permit_days}} - Days</td>
                <td *ngIf="dataCntrl['permittype'].permit_days > 1">{{dataCntrl['permittype'].permit_days}} - Days</td> -->

                <td >{{ formatCurrency(dataCntrl['permittype'].current_application_fee) }}</td>

                <td  *ngIf="chargeInd ==2">{{formatCurrency(dataCntrl['permittype'].current_fee)}}</td>
                <td  *ngIf="chargeInd !=2"></td>
                
                <td style="text-align:right;">{{ formatCurrency(lineTotal) }}</td>
              </tr>
        </ng-container>
        <tr>
          <td colspan="7" style="text-align:right;">Total</td>

          <td style="text-align:right;"> {{ formatCurrency(totalFee) }}</td>
        </tr>
        <tr>
          <td colspan="6" rowspan="3" align="center" [ngClass]="{'error-color':chargeInd!=0}" >
            Fees shown in red are due on submission of the application. The remaining fee(s) if any will be payable before any permit is issued. These fees could change later
          </td>
          <td  style="text-align:right;width:200px;" [ngClass]="{'error-color':chargeInd!=0}">Payable on submission </td>

          <td style="text-align:right;" [ngClass]="{'error-color':chargeInd!=0}"> {{submissionAmt }}</td>
        </tr>
        <tr>
          <td  style="text-align:right;">Amount paid </td>

          <td style="text-align:right;"> {{paidAmt }}</td>
        </tr>
        <tr>
          <td  style="text-align:right;" class="error-color">Amount due now</td>

          <td style="text-align:right;" class="error-color"> {{dueAmt }}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <tbody >
        <tr *ngIf="isProcess || renewFlag">
          <td colspan="2" style="border:0px;border-bottom:1px solid #ccc;text-align:center;" [innerHTML]="linkhtml.Value"></td>
        </tr>
        <tr *ngIf="isProcess || renewFlag">
          <td  style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;border-right:1px solid #ccc;">Declaration by {{userDetails.FirstName}} {{userDetails.LastName}} on <strong>{{decl_date|date : 'dd/MM/yyyy'}}</strong></td>
          <td  style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;">
            <span>You declare that you agree with the declaration above by checking the box:
            </span>
            <input type="checkbox" style="position:relative;top:2px;transform: scalse(1.5);margin-left:8px;" ([ngModel])="termsFlag" (click)="checkTerms($event)" name="terms" />
          </td>
        </tr>

        <tr *ngIf="isCompletePayment">
          <td colspan="2" style="border:0px;text-align:left;padding-top:20px;">
            <button type="button" class="btn hd-btn-close" (click)="closePage()">Close</button>
            <button title="Back" (click)="goBack()" type="submit" id="" type="button" class="btn hd-btn">Back</button>
            <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="SubmitApplication()"
                    [disabled]="!this.termsFlag" type="submit" id="" type="button" class="btn hd-btn">Submit
            </button>
            
          </td>
        </tr>

        <tr *ngIf="(isProcess || renewFlag) && !isCompletePayment">
            <td colspan="2" style="border:0px;text-align:left;padding-top:20px;">
            <button type="button" class="btn hd-btn-close btn-sm" (click)="closePage()">Close</button>
            <button title="Back" (click)="goBack()" type="submit" type="button" class="btn hd-btn">Back</button>
            
            <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="SubmitApplication()"
                    [disabled]="!this.termsFlag" type="submit"  type="button" class="btn hd-btn">Pay with Account Balance
            </button>
            <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="PayGate()"
                    [disabled]="!this.termsFlag" type="submit"  type="button" class="btn  hd-btn ">Pay with Bank Card
            </button>
            </td>
        </tr>

        <tr *ngIf="branch == 'C' || branch == 'F' ">
            <td colspan="2" style="border:0px;text-align:left;padding-top:20px;">
            <button type="button" class="btn hd-btn-close btn-md" (click)="closePage()">Close</button>
            <button title="Back" (click)="goBack()" type="submit" type="button" class="btn hd-btn btn-md">Back</button>
            <button title="Confirm" *ngIf="isProcess && isExternalRole" (click)="PermitDetailsConfirmation()" name="download"
                    type="submit" type="button" class="btn hd-btn btn-md">Confirm
            </button>
            </td>
        </tr>
        <tr *ngIf="!isProcess && !isCompletePayment">
          <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
            <button type="button" class="btn hd-btn-close btn-md" (click)="closePage()">Close</button>
            </td>
        </tr>


      </tbody>
    </table>
 </div>
<!--end of changes-->

<!-- <div class="row s-content">
  <div class="col-md-6">
    Route:
  </div>
  <div class="col-md-6 form-inline"  [ngClass]="{'height-50px' : selectedRoute.source !== null && selectedRoute.source !== undefined && selectedRoute.destination !== null && selectedRoute.destination !== undefined }">
    {{dataCntrl.application.route_summary}}    <span class="ml-auto"  *ngIf="selectedRoute.source !== null && selectedRoute.source !== undefined && selectedRoute.destination !== null && selectedRoute.destination !== undefined">
      <app-route-viewer-map mapid="map-selected-route" [source]="selectedRoute.source" [destination]="selectedRoute.destination"></app-route-viewer-map>
  </span>

  </div>
</div> -->

<br/>


<!-- <p style="color: #FE0606;">Fees shown in red are due on submission of the application. The remaining fees if any will be
    payable before the issuing of the permit.</p>
<br>
<div class="row s-content">
    <div class="col-md-6">
        Payable on submission:
    </div>
    <div class="col-md-6">
        {{submissionAmt }}
    </div>
</div>
<div class="row s-content">
    <div class="col-md-6">
        Amount paid:
    </div>
    <div class="col-md-6">
        {{paidAmt }}
    </div>
    <div class="col-md-6">
        Amount due now:
    </div>
    <br>
    <div class="col-md-6">
        {{dueAmt }}
    </div>
</div>

<div class="row" style="border-bottom: 1px solid black; margin-left: 1px; ">

</div>
<br>
<div class="row s-content">
    <div class="col-md-6" style="font-weight: bold;">
        Total:
    </div>
    <div class="col-md-6" style="color: #FE0606;">
        {{ formatCurrency(totalFee) }}
    </div>
</div>
<br> -->
<!-- <div *ngIf="isExternalRole">
    <header>
        <h1 class="opensans-semi-bold-sapphire-30px">Declaration</h1>
         <span><img class="vector-4" src="../../../../../assets/img/border-color-13@2x.png" height="20" alt="Vector 4" class="pull-icon"  />
         </span>
    </header>
    <p style="margin: 8px;">I declare that the particulars furnished on this form are true and correct.</p>
    <p style="margin: 8px;">Please note that your application will not be approved until the permit fees have been paid in full.</p>
    <strong><p style="margin: 8px;">Declaration by {{userDetails.FirstName}} {{userDetails.LastName}}
        on {{decl_date|date : 'dd/MM/yyyy'}}</p></strong>
    <br>
    <input style="margin: 8px;" type="checkbox" ([ngModel])="termsFlag" (click)="checkTerms($event)" name="terms"/>
    <span style="color: #FE0606;">By clicking the box,you declare that you agree with the declaration above</span>
</div> -->
<!-- <div class="col-12 no-mp" *ngIf="isCompletePayment">
    <button type="button" class="btn hd-btn-close" (click)="closePage()">Close</button>
    <button title="Back" (click)="goBack()" type="submit" id="" type="button" class="btn hd-btn">Back</button>
    <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="SubmitApplication()"
            [disabled]="!this.termsFlag" type="submit" id="" type="button" class="btn hd-btn">Submit
    </button>
</div>
<div class="col-12 no-mp" *ngIf="(isProcess || renewFlag) && !isCompletePayment">
    <button type="button" class="btn hd-btn-close" (click)="closePage()">Close</button>
    <button title="Back" (click)="goBack()" type="submit" type="button" class="btn hd-btn">Back</button>
    <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="SubmitApplication()"
            [disabled]="!this.termsFlag" type="submit"  type="button" class="btn hd-btn">Pay with Account Balance
    </button>
    <button *ngIf="isExternalRole" title="Submit Application" name="SubmitApplication" (click)="PayGate()"
            [disabled]="!this.termsFlag" type="submit"  type="button" class="btn hd-btn">Pay with Bank Card
    </button>
</div>
<div class="col-12 no-mp" *ngIf="branch == 'C' || branch == 'F' ">
    <button type="button" class="btn hd-btn-close" (click)="closePage()">Close</button>
    <button title="Back" (click)="goBack()" type="submit" type="button" class="btn hd-btn">Back</button>
    <button title="Confirm" *ngIf="isProcess && isExternalRole" (click)="PermitDetailsConfirmation()" name="download"
            type="submit" type="button" class="btn hd-btn">Confirm
    </button>
</div>
<div class="col-12 no-mp" *ngIf="!isProcess && !isCompletePayment">
    <button type="button" class="btn hd-btn-close" (click)="closePage()">Close</button>
</div> -->

<!-- OLD DESIGN DISPLAYED TO NONE -->
<div class="content" id="permitConfirm" style="display: none;">
    <div class="container-fluid Confirmation-invoice">
        <div class="content" id="PDFcontent">
            <div class="confirmation-block" id="confirm-content">
                <div class="col-md-12 p-0 ">
                    <div class="card border-light shadow-sm">
                        <div class="row mb-3 " #content id="pdfContent">
                            <div style="margin-top:10px;margin-bottom:0px;margin-left:20px;" class="col-sm-5 p-0">
                                <div class="col-md-12">

                                    <h5 style="margin-top:-10px; margin-bottom: 10px; margin-left:-20px; font-size: 105%; font-weight:700;">
                                        <!-- <span></span> -->
                                        <!-- <b>Proforma Invoice and Confirmation </b> -->
                                        PROFORMA INVOICE AND CONFIRMATION
                                    </h5>

                                    <table id="pdfTable1" width="700">
                                        <tbody>
                                        <tr>
                                            <!-- <th><span class = "head-text">Invoice:</span></th>
                                            <td><span > {{invoiceNumber}}</span></td> -->
                                            <td width="20%"><b>Account No : </b></td>
                                            <td width="80%">{{debtorAccountId}}</td>
                                        </tr>
                                        <tr>
                                            <td height="28px"><b>Application No : </b></td>
                                            <td>{{dataCntrl['application'].id}}</td>
                                        </tr>
                                        <tr>
                                            <td height="28px"><b>Application Date : </b></td>
                                            <td>{{dataCntrl['application'].date_created | date :'dd/MM/yyyy'}}</td>
                                        </tr>
                                        <!-- <tr>
                                          <td><span class = "head-text">My Reference:</span></td>
                                          <td><span >{{dataCntrl['application'].reference_num}}</span></td>
                                        </tr> -->
                                        <tr>
                                            <td height="28px"><b>Applicant : </b></td>
                                            <td>{{dataCntrl['carrier'].name}}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Email Address : </b></td>
                                            <td>{{userDetails.EmailAddress}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style="margin-top:35px;margin-bottom:0px; margin-left: 250px; font-size:93%"
                                 class="col-sm-2 p-0">
                                <div class="col-md-12 p-0">
                <span style="margin-top: 95px; margin-left:-40px;">
                  <span></span>
                  <b>Physical Address</b>
                </span>
                                    <table id="pdfTable2" width="530">
                                        <tbody>
                                        <tr>
                                            <td width="20%" height="15"><b>Address : </b></td>
                                            <td width="80%">{{dataCntrl['carrier'].physical_address_1}}</td>
                                        </tr>
                                        <!-- <tr>
                                          <td class="addrees-td"><span class = "head-text">Address Line2:</span></td>
                                          <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_2}}</span></td>
                                        </tr>
                                        <tr>
                                          <td class="addrees-td"><span class = "head-text">Address Line3:</span></td>
                                          <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_3}}</span></td>
                                        </tr> -->
                                        <tr>
                                            <td height="15"><b>Town : </b></td>
                                            <td>{{dataCntrl['carrier'].physical_address_town}}</td>
                                        </tr>
                                        <tr>
                                            <td height="15"><b>Post Code : </b></td>
                                            <td>{{dataCntrl['carrier'].physical_post_code}}</td>
                                        </tr>
                                        <tr>
                                            <td height="15"><b>Country : </b></td>
                                            <td>{{country}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card border-light shadow-sm">
                        <div class="pull-right">

                            <table id="pdfTable3" style="width:100%;">
                                <tbody>
                                <tr>
                                    <th>Route:<b><span
                                            style="color: black;">{{dataCntrl.application.route_summary}}</span></b>
                                    </th>

                                </tr>

                                <tr>
                                    <!--<td width="80%">{{dataCntrl.application.route_detail}}</td>
                                      <td width="80%" [innerHTML]=" pagehtml" >{{dataCntrl.application.route_detail}}</td> -->

                                   <!--  <p [innerHTML]="pagehtml"></p>
                                    <p *ngIf="selectedRoute.source !== null && selectedRoute.source !== undefined && selectedRoute.destination !== null && selectedRoute.destination !== undefined">
                                        <app-route-viewer-map mapid="map-selected-route"
                                                              style="height: 200px;"
                                                              [source]="selectedRoute.source"
                                                              [destination]="selectedRoute.destination"></app-route-viewer-map> 
                                    </p>-->
                                </tr>


                                </tbody>
                            </table>

                        </div>

                    </div>

                    <!-- <div class="card border-light shadow-sm">
                       <div class="pull-right">
                         <div class="row">
                           <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
                             <h6>
                               <span style="padding-right:5px"></span>
                               <i class="fa fa-globe"></i>
                               <b>Route:  </b> <span style="color:lightgray">
                                 <a class="red-asterik">*</a> Please give a full description of your route
                               </span>
                               <b><span style="color: black;">{{dataCntrl.application.route_summary}}</span></b>
                             </h6>
                           </div>
                         </div>

                           <div class="col-md-12 p-0">

                             <div class=" form-group ">

                               <ckeditor title="" [readonly]="isDuplicateMode || !isProcess || isStandard || !isStandard && frghtPass=='A' || isLongTermCorrection"
                               debounce="500" [ngModel]="dataCntrl.application.route_detail">
                               </ckeditor>

                               </div>
                             </div>



                         </div>
                         </div>-->

                    <div class="card border-light shadow-sm">
                        <div class="pull-right">
                            <table id="pdfTable4">
                                <tbody>
                                <tr>
                                    <th style="padding-right:5px;">Account Balance :</th>
                                    <td [ngClass]="{'error-color':accBalance < 0}">{{dataCntrl['carrier'].account_balance == null ? ' R 0.00' : dataCntrl['carrier'].account_balance}}</td>
                                </tr>

                                </tbody>
                            </table>

                        </div>

                        <table class="table table-striped" id="pdfTable">
                            <thead>
                            <tr>
                                <th>Vehicle Registration</th>
                                <th>Vehice Type</th>
                                <th>Start Date</th>
                                <th>Permit Type</th>
                                <th>Duration</th>
                                <th>Application Fee</th>
                                <th>Permit Fee</th>
                                <th style="text-align:right;">Line Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <ng-container *ngIf="vehicles.length>0">
                                <tr *ngFor="let list of vehicles">
                                    <td>{{list.registration_number}}</td>
                                    <td>{{list.vehicle_type}}</td>
                                    <td>{{list.start_date}}</td>
                                    <td>{{dataCntrl['permittype'].description}}</td>
                                    <ng-container *ngIf="ptype == null">
                                        <td *ngIf="dataCntrl['permittype'].permit_years == 1">{{dataCntrl['permittype'].permit_years}}
                                            - Year
                                        </td>
                                        <td *ngIf="dataCntrl['permittype'].permit_years > 1">{{dataCntrl['permittype'].permit_years}}
                                            - Years
                                        </td>
                                        <td *ngIf="dataCntrl['permittype'].permit_months == 1">{{dataCntrl['permittype'].permit_months}}
                                            - Month
                                        </td>
                                        <td *ngIf="dataCntrl['permittype'].permit_months > 1">{{dataCntrl['permittype'].permit_months}}
                                            - Months
                                        </td>
                                        <td *ngIf="dataCntrl['permittype'].permit_days == 1">{{dataCntrl['permittype'].permit_days}}
                                            - Day
                                        </td>
                                        <td *ngIf="dataCntrl['permittype'].permit_days > 1">{{dataCntrl['permittype'].permit_days}}
                                            - Days
                                        </td>
                                    </ng-container>
                                    <ng-container *ngIf="ptype != null">
                                        <td *ngIf="ptypeYears == 1">{{ptypeYears}} - Year</td>
                                        <td *ngIf="ptypeYears > 1">{{ptypeYears}} - Years</td>
                                        <td *ngIf="ptypeMonth == 1">{{ptypeMonth}} - Month</td>
                                        <td *ngIf="ptypeMonth > 1">{{ptypeMonth}} - Months</td>
                                        <td *ngIf="ptypeDays == 1">{{ptypeDays}} - Day</td>
                                        <td *ngIf="ptypeDays > 1">{{ptypeDays}} - Days</td>
                                    </ng-container>
                                    <td [ngClass]="{'error-color':chargeInd!=0}">{{formatCurrency(list.application_fee)}}</td>
                                    <td [ngClass]="{'error-color':chargeInd==2}">{{formatCurrency(list.permit_fee)}}</td>
                                    <td style="text-align: right;">{{formatCurrency(lineTotal)}}</td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="vehicles==null ||vehicles.length==0">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{dataCntrl['permittype'].description}}</td>
                                    <td *ngIf="dataCntrl['permittype'].permit_years == 1">{{dataCntrl['permittype'].permit_years}}
                                        - Year
                                    </td>
                                    <td *ngIf="dataCntrl['permittype'].permit_years > 1">{{dataCntrl['permittype'].permit_years}}
                                        - Years
                                    </td>
                                    <td *ngIf="dataCntrl['permittype'].permit_months == 1">{{dataCntrl['permittype'].permit_months}}
                                        - Month
                                    </td>
                                    <td *ngIf="dataCntrl['permittype'].permit_months > 1">{{dataCntrl['permittype'].permit_months}}
                                        - Months
                                    </td>
                                    <td *ngIf="dataCntrl['permittype'].permit_days == 1">{{dataCntrl['permittype'].permit_days}}
                                        - Days
                                    </td>
                                    <td *ngIf="dataCntrl['permittype'].permit_days > 1">{{dataCntrl['permittype'].permit_days}}
                                        - Days
                                    </td>

                                    <!--                        <td >{{list.application_fee}}</td>-->
                                    <!--                        <td></td>-->
                                    <!--                        <td style="text-align:right;">{{list.application_fee}}</td>-->
                                </tr>
                            </ng-container>
                            <tr>
                                <td colspan="7" style="text-align:right;">Total</td>

                                <td style="text-align:right;"> {{ formatCurrency(totalFee) }}</td>
                            </tr>
                            <tr>
                                <td colspan="6" rowspan="3" align="center" [ngClass]="{'error-color':chargeInd!=0}">
                                    Fees shown in red are due on submission of the application. The remaining fee(s) if
                                    any will be payable before any permit is issued. These fees could change later
                                </td>
                                <td style="text-align:right;width:200px;" [ngClass]="{'error-color':chargeInd!=0}">
                                    Payable on submission
                                </td>

                                <td style="text-align:right;"
                                    [ngClass]="{'error-color':chargeInd!=0}"> {{submissionAmt }}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right;">Amount paid</td>

                                <td style="text-align:right;"> {{paidAmt }}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right;" class="error-color">Amount due now</td>

                                <td style="text-align:right;" class="error-color"> {{dueAmt }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <table>
                            <tbody>
                            <tr *ngIf="isProcess || renewFlag">
                                <td colspan="2" style="border:0px;border-bottom:1px solid #ccc;text-align:center;"
                                    [innerHTML]="linkhtml.Value"></td>
                            </tr>
                            <tr *ngIf="isProcess || renewFlag">
                                <td style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;border-right:1px solid #ccc;">
                                    Declaration by {{userDetails.FirstName}} {{userDetails.LastName}} on
                                    <strong>{{decl_date|date : 'dd/MM/yyyy'}}</strong></td>
                                <td style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;">
                    <span>You declare that you agree with the declaration above by checking the box:
                    </span>
                                    <input type="checkbox"
                                           style="position:relative;top:2px;transform: scalse(1.5);margin-left:8px;"
                                           ([ngModel])="termsFlag" (click)="checkTerms($event)" name="terms"/>
                                </td>
                            </tr>

                            <tr *ngIf="isCompletePayment">
                                <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
                                    <button title="Cancel" (click)="cancelApplication()" name="download" type="submit"
                                            id="" class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px; ">Close
                                    </button>
                                    <button title="Submit Application"
                                            name="SubmitApplication" (click)="SubmitApplication()"
                                            [disabled]="!this.termsFlag" type="submit" id=""
                                            class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px;">Submit Application
                                    </button>

                                </td>
                            </tr>
                            <br>

                            <tr *ngIf="(isProcess || renewFlag) && !isCompletePayment">
                                <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
                                    <button class="btn btn-md m-clr pull-right hd-btn mt-0" (click)="backToTab()"
                                            title="Back" style="float: left !important;">Back
                                    </button>
                                    <button title="Cancel" (click)="cancelApplication()" name="download" type="submit"
                                            id="" class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px; ">Close
                                    </button>
                                    <button title="Submit Application"
                                            name="SubmitApplication" (click)="SubmitApplication()"
                                            [disabled]="!this.termsFlag" type="submit" id=""
                                            class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px;">Submit Application
                                    </button>

                                </td>
                            </tr>

                            <tr *ngIf="branch == 'C' || branch == 'F' ">
                                <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
                                    <button class="btn btn-md m-clr pull-right hd-btn mt-0" (click)="backToTab()"
                                            title="Back" style="float: left !important;">Back
                                    </button>
                                    <!-- <button title="Cancel" (click)="cancelApplication()"  name="download" type="submit" id=""  class="btn btn-md m-clr pull-right hd-btn" style=" margin-right:10px;margin-bottom:5px; ">Cancel</button> -->
                                    <button title="Confirm" *ngIf="isProcess" (click)="PermitDetailsConfirmation()"
                                            name="download" type="submit"
                                            class="btn btn-md m-clr pull-right hd-btn"
                                            style="margin-right:10px;margin-bottom:5px; ">Confirm
                                    </button>
                                </td>

                            </tr>
                            <tr *ngIf="!isProcess && !isCompletePayment">
                                <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
                                    <button class="btn btn-md m-clr pull-right hd-btn mt-0" (click)="backtoApp()"
                                            title="Back" style="float: left !important;">Back
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
        <!--<div class="col-md-12 p-0" id="ignoreContent">
          <button title="Download PDF" name="download" type="submit" id="btnSave" (click)="downloadPdf()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Download PDF</button>
      </div>-->
    </div>
</div>


